import { TMatchMenu } from "@/features/match/types/matchMenu";
import { AppRoutes } from "@/routes/config";

export const matchMenu: TMatchMenu[] = [
  {
    title: "契約中",
    url: AppRoutes.duringContractList,
    extraUrls: [],
  },
  {
    title: "解約済み",
    url: AppRoutes.trialMatchList,
    extraUrls: [],
  },
  {
    title: "トライアル中",
    url: AppRoutes.trialCancelledList,
    extraUrls: [],
  },
  {
    title: "トライアル終了",
    url: AppRoutes.canceledContractList,
    extraUrls: [],
  },
];

export const getMatchMenu = (count?: {
  during_contract?: number;
  canceled_contract?: number;
  trial?: number;
  trial_cancelled?: number;
}): TMatchMenu[] => [
  {
    title: `契約中 (${count?.during_contract ?? 0})`,
    url: AppRoutes.duringContractList,
    extraUrls: [],
  },
  {
    title: `解約済み (${count?.canceled_contract ?? 0})`,
    url: AppRoutes.canceledContractList,
    extraUrls: [],
  },
  {
    title: `トライアル中 (${count?.trial ?? 0})`,
    url: AppRoutes.trialMatchList,
    extraUrls: [],
  },
  {
    title: `トライアル終了 (${count?.trial_cancelled ?? 0})`,
    url: AppRoutes.trialCancelledList,
    extraUrls: [],
  },
];
